import Record from "./base"

export class Applicant extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
